export interface Config {
  server_url: string;
  request_object_url: string;
  unsigned_client_id: string;
  response_type: string,
  client_id: string;
}

const configProd: Config = {
  server_url: "https://mdl-verifier.mynext.id",
  request_object_url: "https://mdl-verifier.mynext.id/api/v1/request_object",
  client_id: "https://mdl-verifier.mynext.id",
  unsigned_client_id: "https://mdl-verifier.mynext.id/api/v1/authorization_response?tx_id=",
  response_type: "vp_token",
};

const configLocal: Config = {
  server_url: "http://localhost:8003",
  request_object_url: "http://localhost:8003/api/v1/request_object",
  client_id: "https://mdl-verifier.mynext.id",
  unsigned_client_id: "https://mdl-verifier.mynext.id/api/v1/authorization_response?tx_id=",
  response_type: "vp_token",
};

const cfg: any = {
  "https://mdl-verifier.mynext.id": configProd,
  "http://localhost:8003": configLocal,
}
const url = window.location.origin;

export default (cfg[url]);
